/**
 * FOTOGRAVUR RÜCKSEITE – Erweiterung für fotogravur-preview2.js (Haustier-Andenken, 11.10.2026)
 * Gleiches Prinzip wie designer-rueckseite.js / hochzeit-rueckseite.js: Reiter „Vorderseite /
 * Rückseite" über der Vorschau, Schalter + drei Textzeilen darunter, Aufpreis über die
 * Varianten-Option „Rückseite" (ohne / mit), Texte als Eigenschaften „Rückseite Zeile 1–3".
 * Rückseite in der Schrift der Vorderseite, 20 % kleiner (wie beim Designer).
 */
(function () {
  'use strict';

  var LINES = ['fg-back-line1', 'fg-back-line2', 'fg-back-line3'];
  var OPTION = window.FG_RUECKSEITE_OPTION || 'Rückseite';

  function $(id) { return document.getElementById(id); }

  // fotogravur-preview2.js legt FotogravurPreview als const an (kein window-Property)
  function DP() {
    try { return FotogravurPreview; } catch (e) { return window.FotogravurPreview; }
  }

  function aktiv() {
    var t = $('fg-back-toggle');
    return !!(t && t.checked);
  }

  function optionSelect() {
    return document.querySelector('select[name="options[' + OPTION + ']"]');
  }

  // ---------- Eigenschaften synchronisieren (aus = deaktiviert, landet nicht in der Bestellung)
  function syncHidden() {
    var an = aktiv();
    var flag = $('fg-hidden-back');
    if (flag) { flag.value = an ? 'Ja' : ''; flag.disabled = !an; }
    LINES.forEach(function (id, i) {
      var h = $('fg-hidden-back-line' + (i + 1));
      if (h) { h.value = an ? (($(id) || {}).value || '').trim() : ''; h.disabled = !an; }
    });
  }

  // ---------- Hinweis am Preis: „Komplettset · Vorder- und Rückseite graviert"
  function hinweisAktualisieren() {
    var preis = document.querySelector('.product__price-and-ratings') || document.querySelector('.product__price');
    if (!preis) { return; }
    var el = document.getElementById('nm-konfig-hinweis');
    if (!el) {
      el = document.createElement('div');
      el.id = 'nm-konfig-hinweis';
      el.style.cssText = 'font-size:13px;color:#115E16;margin:2px 0 6px;font-weight:600;';
      preis.parentNode.insertBefore(el, preis.nextSibling);
    }
    var ausf = document.querySelector('select[name="options[Auswahl]"]');
    var ausfText = ausf ? ausf.value : '';
    el.textContent = (ausfText ? ausfText + ' · ' : '') + (aktiv() ? 'Vorder- und Rückseite graviert (+ 8,00 €)' : 'nur Vorderseite graviert');
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('select[name^="options["]')) { setTimeout(hinweisAktualisieren, 50); }
  }, true);

  // ---------- Variante umschalten (Theme aktualisiert Preis/Variante selbst)
  function varianteSetzen() {
    var sel = optionSelect();
    if (!sel) { return; }
    var werte = Array.prototype.map.call(sel.options, function (o) { return o.value; });
    var ziel = aktiv() ? (werte.find(function (w) { return /mit/i.test(w); }) || werte[1]) : werte[0];
    if (!ziel || sel.value === ziel) { return; }
    sel.value = ziel;
    sel.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
  }

  // Der Kachel-Picker schreibt bei jedem Klick alle Options-Selects neu -> danach wieder setzen
  function kachelWechselAbfangen() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) { return; }
      if (!e.target.closest('.variant-option-card')) { return; }
      setTimeout(varianteSetzen, 60);
      setTimeout(varianteSetzen, 400);
    }, true);
  }

  // ---------- Vorschau: Reiter und Rückseite
  var currentSide = 'front';

  function reiterAnzeigen(side) {
    currentSide = side;
    document.querySelectorAll('#fg-side-tabs button').forEach(function (b) { b.classList.toggle('active', b.dataset.side === side); });
    var felder = $('fg-back-fields');
    if (felder) { felder.style.display = (side === 'back') ? 'block' : 'none'; }
  }

  async function renderBack() {
    var dp = DP();
    if (!dp || !dp.ctx || dp.isRendering) { return; }
    dp.isRendering = true;
    try {
      if (!dp.fontsLoaded && typeof dp.loadFonts === 'function') { await dp.loadFonts(); }
      var W = dp.config.canvasWidth || 800, H = dp.config.canvasHeight || 800;
      var ctx = dp.ctx;
      ctx.clearRect(0, 0, W, H);
      ctx.imageSmoothingEnabled = true;
      if (dp.images.base && dp.images.base.complete) { ctx.drawImage(dp.images.base, 0, 0, W, H); }
      var texte = LINES.map(function (id) { return (($(id) || {}).value || '').trim(); }).filter(function (t) { return t; });
      var tc = dp.config.textConfig || { x: 400, fontSize: 48, color: '#4a4a4a' };
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      if (!texte.length || !aktiv()) {
        ctx.font = '30px "Montserrat", sans-serif';
        ctx.fillStyle = '#9aa39b';
        ctx.fillText(aktiv() ? 'Rückseite: noch kein Text' : 'Rückseite ohne Gravur', tc.x || 400, 470);
        return;
      }
      var fd = (typeof dp.getFormData === 'function') ? dp.getFormData() : { font: 'Pixie Ring' };
      var fontData = dp.config.fontConfig && dp.config.fontConfig[fd.font];
      var fontName = fontData ? fontData.name : 'Pixie Ring';
      var size = Math.round((tc.fontSize || 48) * 0.8);   // Schrift wie vorne, 20 % kleiner
      var abstand = Math.round(size * 1.55);
      var maxBreite = 430;                                  // Topfbreite auf Höhe der Zeilen
      var y0 = 470 - ((texte.length - 1) * abstand) / 2;
      ctx.fillStyle = tc.color || '#4a4a4a';
      texte.forEach(function (t, i) {
        var fs = size;
        ctx.font = fs + 'px "' + fontName + '"';
        while (ctx.measureText(t).width > maxBreite && fs > 14) { fs -= 2; ctx.font = fs + 'px "' + fontName + '"'; }
        ctx.fillText(t, tc.x || 400, y0 + i * abstand);
      });
    } catch (e) {
      console.error('Fotogravur Rückseite rendern:', e);
    } finally {
      dp.isRendering = false;
      // Inline-Vorschau zeigen, aber NICHT speichern: persistState soll die Vorderseite behalten
      try {
        var img = $('fg-inline-preview-img');
        if (img && dp.canvas) { img.src = dp.canvas.toDataURL('image/png'); }
      } catch (e2) {}
    }
  }

  function showSide(side, versuch) {
    var dp = DP();
    reiterAnzeigen(side);
    if (!dp) { return; }
    // Läuft gerade noch eine Zeichnung, kurz warten – sonst bliebe das alte Bild stehen
    if (dp.isRendering && (versuch || 0) < 20) { setTimeout(function () { showSide(side, (versuch || 0) + 1); }, 100); return; }
    if (side === 'back') { renderBack(); } else if (typeof dp.renderPreview === 'function') { dp.renderPreview(dp.getFormData()); }
  }

  function toggleFields() {
    var box = $('fg-back-fields');
    if (box) { box.classList.toggle('aus', !aktiv()); }
    syncHidden();
    varianteSetzen();
    setTimeout(hinweisAktualisieren, 80);
    if (currentSide === 'back') { renderBack(); }
  }

  // ---------- Beim (Wieder-)Laden immer ohne Rückseite starten (wie Designer, 02.10.2026)
  // Browser stellen beim Zurückgehen das Häkchen wieder her, die Textzeilen aber nicht ->
  // sonst „mit Rückseite" vorausgewählt, aber leer. Nichts merken, Kunde gibt sie neu ein.
  var nutzerHatEingegeben = false;
  document.addEventListener('input', function (e) { if (e.isTrusted) { nutzerHatEingegeben = true; } }, true);
  document.addEventListener('change', function (e) { if (e.isTrusted) { nutzerHatEingegeben = true; } }, true);

  function zuruecksetzen() {
    var t = $('fg-back-toggle');
    if (t) { t.checked = false; }
    LINES.forEach(function (id) { var el = $(id); if (el) { el.value = ''; } });
    reiterAnzeigen('front');
    toggleFields();
  }

  // Eigenschaften-Reihenfolge im Warenkorb: erst Wunschtext/Schrift/Bild, dann Rückseite.
  // fotogravur-preview2.js hängt seine Felder ins Formular, unsere kommen direkt dahinter.
  function felderInsFormular() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) { return; }
    var anker = $('fg-hidden-image-data');
    var ziel = (anker && form.contains(anker)) ? anker : null;
    ['fg-hidden-back', 'fg-hidden-back-line1', 'fg-hidden-back-line2', 'fg-hidden-back-line3'].forEach(function (id) {
      var f = $(id);
      if (!f) { return; }
      if (ziel) { ziel.insertAdjacentElement('afterend', f); ziel = f; } else if (!form.contains(f)) { form.appendChild(f); }
    });
  }

  // ---------- Start
  function init() {
    var toggle = $('fg-back-toggle');
    if (!toggle) { return; }
    if (!optionSelect()) {                       // Produkt ohne Option „Rückseite": nichts anbieten
      var t0 = $('fg-side-tabs'); if (t0) { t0.remove(); }
      var b0 = $('fg-back-fields'); if (b0) { b0.remove(); }
      return;
    }
    toggle.addEventListener('change', function () {
      toggleFields();
      if (aktiv() && currentSide !== 'back') { showSide('back'); }
    });
    LINES.forEach(function (id) {
      var el = $(id);
      if (!el) { return; }
      el.addEventListener('input', function () {
        var t = $('fg-back-toggle');
        if (t && !t.checked && el.value.trim()) { t.checked = true; toggleFields(); return; }
        syncHidden();
        if (currentSide === 'back') { renderBack(); }
      });
    });
    document.querySelectorAll('#fg-side-tabs button').forEach(function (b) {
      b.addEventListener('click', function () { showSide(b.dataset.side); });
    });

    // Jede Neuzeichnung der Vorderseite (KI-Ergebnis, Wunschtext, Schrift) zeigt wieder vorne an,
    // damit Reiter und Bild nie auseinanderlaufen.
    var dp = DP();
    if (dp && typeof dp.renderPreview === 'function' && !dp._rueckseiteGewickelt) {
      var orig = dp.renderPreview;
      dp.renderPreview = function () {
        reiterAnzeigen('front');
        return orig.apply(this, arguments);
      };
      dp._rueckseiteGewickelt = true;
    }

    felderInsFormular();
    setTimeout(felderInsFormular, 1500);
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      // capture: läuft VOR dem Submit-Handler der Fotogravur (der danach nativ absendet)
      form.addEventListener('submit', function () { syncHidden(); felderInsFormular(); }, true);
    }
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('#fg-add-to-cart-btn, form[action*="/cart/add"] button[type=submit]')) { syncHidden(); felderInsFormular(); }
    }, true);
    kachelWechselAbfangen();
    zuruecksetzen();
    // Manche Browser füllen Formulare erst nach DOMContentLoaded wieder auf
    window.addEventListener('load', function () { if (!nutzerHatEingegeben) { zuruecksetzen(); } });
    // Seite aus dem Zurück-Cache (bfcache): Zustand stammt vom letzten Besuch
    window.addEventListener('pageshow', function (e) { if (e.persisted) { zuruecksetzen(); } });
    setTimeout(hinweisAktualisieren, 600);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
